<template>
  <div>
    <h1>Compras</h1>

    <div v-if="loading">Loading...</div>
    <div v-else>
      <!-- chips per gruop -->
      <v-chip-group>
        <v-chip
          @click="groupFilter = groupFilter == group.value ? '' : group.value"
          :outlined="groupFilter != group.value"
          class="ma-1"
          v-for="group in groupsList"
          :key="group.value"
        >
          {{ group.text }}
        </v-chip>
      </v-chip-group>
      <!-- chips per person -->
      <v-chip-group>
        <v-chip
          @click="personFilter = personFilter == person ? '' : person"
          :outlined="personFilter != person"
          class="ma-1"
          v-for="(value, person) in spentPerPerson"
          :key="person"
        >
          {{ value.nickname }}: {{ value.amount }}
        </v-chip>
      </v-chip-group>
      <!--actual list-->
      <div
        v-for="purchase in purchasedFiltered"
        :key="purchase.option.id"
        @click="
          $router.push(
            `/regalos/campaign/${purchase.campaign.id}/idea/${purchase.idea.id}/option/${purchase.option.id}/view`
          )
        "
        style="cursor: pointer"
      >
        <div style="margin: 10px 0px">
          <div style="display: flex; align-items: left; padding: 8px">
            <ImagesStacked :images="[purchase.option.image_url]" :size="65" :max-visible="2" />
            <div style="margin-left: 8px; border-bottom: 1px solid #ccc">
              {{ purchase.campaign.title }} / {{ purchase.idea.title }}
              <p>
                {{ purchase.option.price }} {{ purchase.option.currency || 'EUR' }} - Comprado por
                {{ purchase.option.paidBy || 'Nadie' }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/assets/api'
//import OpcionListItem from './OpcionListItem.vue'
import ImagesStacked from './ImagesStacked.vue'
import { nickname, groups } from './regalos-data'

export default {
  components: {
    // OpcionListItem,
    ImagesStacked,
  },
  data() {
    return {
      loading: false,
      personFilter: '',
      groupFilter: '',
      campaigns: [],
    }
  },
  computed: {
    purchasedFiltered() {
      let x = [...this.purchased]
      if (this.personFilter) {
        x = x.filter((p) => p.option.paidBy === this.personFilter)
      }
      if (this.groupFilter) {
        x = x.filter((p) => p.campaign.group === this.groupFilter)
      }
      return x
    },
    purchased() {
      const x = []
      for (let i = 0; i < this.campaigns.length; i++) {
        const campaign = this.campaigns[i]
        if (!campaign.split_spend) continue
        const ideas = campaign.ideas
        for (let j = 0; j < ideas.length; j++) {
          const idea = ideas[j]
          const options = idea.options
          for (let k = 0; k < options.length; k++) {
            const option = options[k]
            if (!idea.completed || !option.purchased || idea.returned) continue
            x.push({ campaign, idea, option })
          }
        }
      }
      return x
    },
    spentPerPerson() {
      const spent = { total: { nickname: 'Total', amount: 0 } }
      for (let i = 0; i < this.purchased.length; i++) {
        const option = this.purchased[i].option
        const payer = option.paidBy || 'Nadie'
        if (!spent[payer]) spent[payer] = { nickname: nickname(payer), amount: 0 }
        spent[payer].amount += +option.price
        spent[payer].amount = Math.round(spent[payer].amount * 100) / 100
        spent.total.amount += +option.price
      }
      spent.total.amount = spent.total.amount.toFixed(2)
      return spent
    },
    groupsList() {
      const x = []
      this.purchased.forEach((p) => {
        const c = p.campaign
        const v = c.group || 'N/A'
        let group = groups('').find((gr) => gr.value === v)
        if (!group) group = { value: v, text: v }
        const index = x.findIndex((g) => g.value === group.value)
        if (index === -1) x.push(group)
      })
      return x
    },
  },
  methods: {
    async fetchCampaigns() {
      this.loading = true
      let x = await api.apiFetch('/regalos/campaigns', {
        method: 'GET',
      })
      if (!x.ok) return alert('Error fetching campaigns...')
      const j = await x.json()
      this.my_data = j

      const campaignPromises = j.campaigns.map((campaign_id) =>
        api
          .apiFetch(`/regalos/campaign?id=${campaign_id}`)
          .then((y) => (y.ok ? y.json() : null))
          .catch(() => {
            console.warn("couldn't fetch " + campaign_id)
            return null
          })
      )

      const campaignResults = await Promise.all(campaignPromises)
      const campaigns = campaignResults.filter((campaign) => campaign !== null)

      this.campaigns = campaigns.sort((a, b) => {
        return new Date(b.updatedAt) - new Date(a.updatedAt)
      })
      this.loading = false
    },
  },
  mounted() {
    this.fetchCampaigns()
  },
}
</script>

<style lang="scss" scoped></style>
